import { EarthArrowDownIcon } from './EarthArrowDownIcon';

/**
 * author: frankgrinaert
 * id 7EAEFA1D-7544-43E9-A93E-3869A3E50CB4
 * name earth-arrow-down
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-arrow-down.svg
 * tags
 */
export const WorldArrowDownIcon = EarthArrowDownIcon;
export default WorldArrowDownIcon